import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import PortalLogin from '../components/PortalLogin';

const AdminLogin = () => {
  const navigate = useNavigate();
  return (
    <PortalLogin
      subtitle="Admin Portal"
      icon={ShieldCheck}
      allowedRoles={['admin']}
      onSuccess={() => navigate('/admin')}
      testIdPrefix="admin"
    />
  );
};

export default AdminLogin;
